import clsx from 'clsx';
import React from 'react';
import './UiGrid.css';
export function UiGrid(_a) {
    var _b = _a.spacing, spacing = _b === void 0 ? 2 : _b, _c = _a.outerSpacing, outerSpacing = _c === void 0 ? 0 : _c, minMax = _a.minMax, fullWidth = _a.fullWidth, children = _a.children, className = _a.className;
    var classNameList = clsx('UiGrid', "spacing-" + spacing, "outer-spacing-" + outerSpacing, fullWidth && 'fullWidth', className);
    var style = {};
    if (minMax) {
        style.gridTemplateColumns = "repeat(auto-fill, minmax(" + minMax + "px, 1fr))";
    }
    return (React.createElement("div", { className: classNameList, style: style }, children));
}
UiGrid.displayName = 'UiGrid';
